import { IInitialState } from "../types/initialState.types";

const initialState: IInitialState = {
  apiCallStatus: {},
  auth: {
    userIdentityData: null,
    otp: {
      otpError: null,
      otpLoading: false,
    },
  },
  platformMeta: null,
  interviewConfig: null,
  zoomClient: {
    client: null,
    stream: null,
  },
  zoomGlobal: {
    zoomVideoStarted: false,
    zoomAudioStarted: false,
    userId: null,
    zoomAction: null,
    zoomConnectionStatus: null,
  },
  interviewPermissions: {
    isErrorInAudioPermission: false,
    isErrorInVideoPermission: false,
    isVideoEnabled: true,
    isAudioEnabled: true,
    isLocalFeedRunning: false,
    isVideoStreamingEnded: false,
    isAudioStreamingEnded: false,
  },
  chat: [],
  codeEditor: {
    isCodeEditorLibraryLoaded: false,
    technologies: {},
    theme: "vs",
  },
  codingProblems: {
    customInputResults: {},
    testCaseResults: {},
    isRunCodeInProcess: {},
    isAbortInProcess: {},
  },
  questionsDetails: {
    questions: {},
    candidateActiveQuestionSlug: null,
  },
  library: {
    problems: [],
    meta: null,
  },
  progress: {},
  interview: null,
  interviewerRatings: {
    id: null,
    slug: null,
    evaluation_ratings: {},
    interview_name: null,
    status: null,
    feedbackSlug: "",
    question_ratings: {},
  },
  participants: {},
  socket: {
    socket: null,
  },
  serverTime: {
    serverTime: null,
    initialClientTime: null,
    isSystemTimeMismatch: false,
    offsetTime: 0,
  },
  appStatus: {
    multiTabDetected: false,
    errorPage: null,
    toast: null,
    userJoinLeaveNotification: null,
    whitelabelingEnabled: null,
  },
  modal: {
    confirmModal: null,
    notificationModal: null,
  },
  createQuestionModal: {
    show: false,
    questionsDetails: null,
  },
  solutions: {
    allSolutions: {},
    isSolutionsGet: {},
    whiteboardSolutions: {},
    subjectiveSolutions: {},
  },
  collabTemporaryData: {
    whiteboardCollobarators: {},
    drawingSyncData: {},
    codeSyncData: {},
    subjectiveSyncData: {},
    subjectiveCursors: {},
  },
};

export default initialState;
